import { useTranslation } from "react-i18next";

const GenericNotFound = () => {
  
  const { t } = useTranslation();
  return (
    <>
      <div className='pageNotFound'>
        <h2 style={{'fontSize':'100pt', 'textAlign': 'center','paddingTop':'150px'}}>404</h2>
        <div style={{'fontSize':'20pt', 'textAlign': 'center','paddingTop':'50px'}}>{t("LT_page_not_found")}...</div>
      </div>
    </>
  );
};

export default GenericNotFound;
